import React from 'react';

export const SingleLineAnswerField = ({
	fieldValue = null,
	onAnswerChange
}) => {

	return (
		<div>
			<input type="text"
				className="form-control"
				value={fieldValue ?? ''}
				onChange={(e) => onAnswerChange(e.target.value)} 
				maxLength={255}
				/>
		<div className='text-end text-secondary'>  {fieldValue.length + '/255 characters remaining'}</div>
		</div>
	);
};

export default SingleLineAnswerField;
